import { useState } from 'react';

export default function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: 'Carlos Eduardo Silva',
      role: 'Cliente Residencial',
      text: 'Contratei a JB Pinturas para pintar minha casa e fiquei impressionado com a qualidade do serviço! A equipe é muito profissional, pontual e deixou tudo impecável. Recomendo de olhos fechados!',
      rating: 5,
    },
    {
      name: 'Marina Santos Costa',
      role: 'Síndica de Condomínio',
      text: 'Excelente trabalho na pintura do nosso condomínio! A JB Pinturas cumpriu todos os prazos, trabalhou com muito cuidado e o resultado ficou maravilhoso. Equipe muito educada e competente.',
      rating: 5,
    },
    {
      name: 'Roberto Oliveira',
      role: 'Empresário',
      text: 'Precisava pintar meu estabelecimento comercial e a JB Pinturas fez um trabalho excepcional! Trabalharam em horários que não atrapalharam meu negócio e o acabamento ficou perfeito.',
      rating: 5,
    },
    {
      name: 'Ana Paula Ferreira',
      role: 'Proprietária',
      text: 'Fiz a aplicação de textura grafiato na minha casa e adorei o resultado! A equipe da JB Pinturas é muito caprichosa e atenciosa. Valeu cada centavo investido!',
      rating: 5,
    },
    {
      name: 'Família Rodrigues',
      role: 'Cliente Residencial',
      text: 'Reformamos nossa casa com a JB Pinturas e ficamos muito satisfeitos! Além da pintura, fizeram reparos em gesso e rejunte. Tudo ficou perfeito! Empresa de confiança!',
      rating: 5,
    },
    {
      name: 'Marcelo Henrique Lima',
      role: 'Gerente de Propriedade',
      text: 'Trabalho com a JB Pinturas há anos e sempre tive excelentes experiências. São profissionais sérios, comprometidos e entregam um trabalho de altíssima qualidade. Super recomendo!',
      rating: 5,
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            O que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-600">
            Veja os depoimentos de quem confia na JB Pinturas
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 mx-auto mt-4"></div>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {[currentSlide, (currentSlide + 1) % testimonials.length].map((index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-lg p-8 relative transform transition-all duration-500"
                >
                  <div className="absolute top-4 right-4 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-l text-orange-500 text-2xl"></i>
                  </div>
                  <div className="mb-4">
                    <h4 className="font-bold text-gray-800 text-lg">{testimonials[index].name}</h4>
                    <p className="text-gray-600 text-sm">{testimonials[index].role}</p>
                  </div>
                  <div className="flex space-x-1 mb-4">
                    {[...Array(testimonials[index].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 leading-relaxed italic">{testimonials[index].text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-gray-600 text-xl"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  currentSlide === index ? 'bg-orange-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
